/**
 * withSupportTicket
 * HOC for wrapping the provided component with UserProvider
 */

import React from 'react'

import SupportTicketProvider from './support-ticket-provider'

export default function withSupportTicket (WrappedComponent) {
  return function SupportTicketProviderHOC(props) {
    return (
      <SupportTicketProvider>
        <WrappedComponent {...props} />
      </SupportTicketProvider>
    )
  }
}
